import React from 'react';
import ReactDOM from 'react-dom/client';
import FanAnimesOficial from './FanAnimesOficial';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<FanAnimesOficial />);